<!--新增/编辑收货地址 @zjf-2021-01-06-->
<template>
  <div class="address_operate_modal">
    <el-dialog title="添加新港口" v-model="modalVisible" @close="close_dialog">
      <el-form :model="form.data" :rules="rules" ref="ruleForm">
        <el-form-item
          label="发货港口"
          :label-width="formLabelWidth"
          prop="telMobile"
        >
          <el-input
            v-model="form.data.telMobile"
            autocomplete="off"
            placeholder="请输入港口"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label=" " :label-width="formLabelWidth">
          <el-checkbox v-model="form.data.isDefault">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="close_dialog">取 消</el-button>
          <el-button type="primary" @click="addAddress('ruleForm')"
            >确 定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, getCurrentInstance, watchEffect, onMounted } from "vue";
import { useRouter } from "vue-router";
// import areaData from "../assets/area.json";
import { ElMessage } from "element-plus";
export default {
  name: "SldAddressOperation",
  components: {},
  props: ["visibleFlag", "addressInfo", "type1", "changeType"],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const formLabelWidth = "80px";
    const modalVisible = ref(true);
    const form = reactive({ data: {} });
    const areaDataArray = ref([]);
    const cascaderProps = { label: "regionName", value: "regionCode" };
    const ruleForm = ref(null);
    const cascaderAddr = ref(null);
    const addressInfo = reactive(props.addressInfo);
    if (props.type1 == "edit") {
      //   var area = [];
      console.log(form.data);
      //   form.data.memberName = addressInfo.data.memberName;
      form.data.telMobile = addressInfo.data.portName;
      //   form.data.detailAddress = addressInfo.data.detailAddress; //详细地址
      //   form.data.mailbox=addressInfo.data.email//邮箱
      //   form.data.Postcode=addressInfo.data.zipCode//邮编
      form.data.isDefault = addressInfo.data.isDefault ? true : false; //是否默认地址：1-默认地址，0-非默认地址
      //   area.push(
      //     addressInfo.data.provinceCode,
      //     addressInfo.data.cityCode,
      //     addressInfo.data.districtCode,
      //     addressInfo.data.countryCode
      //   );
      //   form.data.area = area;
    } else {
      //  form.data.telMobile = "";
      //  form.data.isDefault= "";
    }

    const rules = {
      telMobile: [{ required: true, message: "请输入港口", trigger: "change" }],
    }; //输入校验
    //增加地址
    const addAddress = () => {
      ruleForm.value.validate((valid) => {
        if (valid) {
          console.log(form.data.portName);
          var param = {
            isDefault: form.data.isDefault,
            portName: form.data.telMobile,
          };

          if (param.isDefault == true) {
            param.isDefault = 1;
          } else {
            param.isDefault = 2;
          }

          var url;
          if (props.type1 == "edit") {
            url = "/v3/member/front/memberDeliverPort/edit";
            param.portId = addressInfo.data.portId;
          } else if (props.type1 == "add") {
            url = "v3/member/front/memberDeliverPort/add";
          }

          proxy
            .$post(url, param)
            .then((res) => {
              if (res.state == 200) {
                close_dialog();
                emit("refreshAddress1", param, res.data, props.changeType); //子传父
                ElMessage.success(res.msg);
                if(!props.changeType){
                  router.push({ path: `/member/address/list` });
                }
              } else {
                ElMessage(res.msg);
              }
            })
            .catch(() => {
              //异常处理
            });
        } else {
          return false;
        }
      });
    };
    const close_dialog = () => {
      emit("close1");
      document.body.style.overflow = "visible";
    };

    onMounted(() => {
      console.log("addressInfo:" + props.addressInfo);
      console.log("changeType:" + props.changeType);
    });
    watchEffect(() => {
      //   modalVisible.value = props.visibleFlag;
      //   console.log(addressInfo)
    });
    return {
      formLabelWidth,
      modalVisible,
      form,
      areaDataArray,
      cascaderProps,
      rules,
      ruleForm,
      addAddress,
      cascaderAddr,
      close_dialog,
    };
  },
};
</script>

<style lang="scss">
.el-cascader-menu__wrap {
  height: 204px !important;
}

.address_operate_modal {
  .el-dialog {
    width: 600px !important;
  }

  .el-cascader {
    width: 100% !important;
  }

  .el-checkbox {
    .el-checkbox__input {
      margin-top: -4px;
    }
  }

  .el-button--primary {
    color: #fff;
    background-color: $colorMain;
    border-color: $colorMain;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: $colorMain;
    border-color: $colorMain;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $colorMain;
  }

  .el-button {
    padding: 9px 20px;
  }

  .el-dialog__body {
    padding: 20px;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .el-form-item__content {
    position: relative;
  }

  .el-form-item__error {
    position: absolute;
    top: 16px;
    right: 25px;
    display: inline-block;
    width: auto;
    z-index: 2;
    background: #fff;
    left: auto;
    padding: 0 3px;
  }

  input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
    font-size: 12px;
  }

  input::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
    font-size: 12px;
  }

  input:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
    font-size: 12px;
  }

  input:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
    font-size: 12px;
  }

  textarea::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
    font-size: 12px;
  }

  textarea::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
    font-size: 12px;
  }

  textarea:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
    font-size: 12px;
  }

  textarea:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
    font-size: 12px;
  }
}
</style>